import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import shared from './shared'
import post from './post'
import message from './message'
import fundraiser from './fundraiser'
import products from './products'
import LogRocket from 'logrocket';


if(window.location.href.indexOf('192.') || window.location.href.indexOf('localhost') ){
  LogRocket.init('htmrw7/zzques_local')
}else{
  LogRocket.init('htmrw7/zzques-prod')
}


import createPlugin from 'logrocket-vuex';

const logrocketPlugin = createPlugin(LogRocket);



Vue.use(Vuex)

//=======================
import VueAxios from 'vue-axios'
import { VueAuthenticate } from 'vue-authenticate'
import axios from 'axios';


Vue.use(VueAxios, axios)

const vueAuth = new VueAuthenticate(Vue.prototype.$http, {
  baseUrl: 'http://localhost:4000',

  providers: {
    github: {
      clientId: '',
      redirectUri: 'http://localhost:8080/auth/callback' // Your client app URL
    }
  }  
})


//=======================

export const store = new Vuex.Store({
  modules: {
    user: user,
    shared: shared,
    post: post,
    message: message,
    fundraiser: fundraiser,
    products: products
  },
  plugins: [logrocketPlugin]
})